var Movement = {
    handle: "movement",
    
    abilities: { 
        quickness: {
            handle: "quickness",
            unlockLevel: 1,
            passive: true 
        },

        adrenaline: {
            handle: "adrenaline",
            unlockLevel: 3 
        },

        leap: {
            handle: "leap",
            unlockLevel: 11 
        },

        stance_dancing: {
            handle: "stance_dancing",
            unlockLevel: 19
        },

        tussle: {
            handle: "tussle",
            unlockLevel: 27 
        },

        freedom: {
            handle: "freedom",
            unlockLevel: 35,
            passive: true
        },

        preparation: {
            handle: "preparation",
            unlockLevel: 43,
            passive: true 
        }  
    }
};
module.exports = Movement;